const cache = new Map<string, string>();

/**
 * Loads an image, removes white/near-white pixels via canvas, returns a
 * transparent PNG data-URL. Results are cached so each source is only
 * processed once per session.
 */
export function removeWhiteBg(src: string, threshold = 240): Promise<string> {
  if (cache.has(src)) return Promise.resolve(cache.get(src)!);

  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d")!;
      ctx.drawImage(img, 0, 0);

      const id = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const d = id.data;
      for (let i = 0; i < d.length; i += 4) {
        if (d[i] >= threshold && d[i + 1] >= threshold && d[i + 2] >= threshold) {
          d[i + 3] = 0; // make transparent
        }
      }
      ctx.putImageData(id, 0, 0);
      const result = canvas.toDataURL("image/png");
      cache.set(src, result);
      resolve(result);
    };
    img.onerror = () => resolve(src); // fallback to original on error
    img.src = src;
  });
}
